module.exports = __webpack_public_path__ + "static/media/Mazaya Still 03.8017fca4.webp";